module.exports = __webpack_public_path__ + "img/ci_both.36ad3a6d.png";